import getRecordById from './getRecordById';
export default function getRecordByRecordId(recordId) {
    const { entityName, id } = recordId;
    const recordObject = getRecordById(entityName, id);
    if (!recordObject) {
        return undefined;
    }
    else {
        return Object.assign(Object.assign({}, recordId), { recordObject });
    }
}
